module.exports = __webpack_public_path__ + "img/index5.d459a1d7.png";